import { button, el } from './dom';

/**
 * Bandeau « connexion perdue » (correctif post-livraison v1.0.1).
 *
 * Il s'affiche dès que la socket tombe alors qu'on est dans une partie —
 * typiquement sur mobile, quand l'onglet passe en arrière-plan (feuille de
 * partage, changement d'application) et que le navigateur ferme la WebSocket.
 * Le client tente déjà de reprendre sa place tout seul ; le bandeau dit ce qui
 * se passe et laisse **toujours** deux issues, pour qu'aucun écran d'attente ne
 * puisse devenir un cul-de-sac.
 */
export interface ConnectionBannerOptions {
  /** Reprise immédiate demandée par l'utilisateur. */
  readonly onRetry: () => void;
  /** Abandon de la partie et retour à l'accueil. */
  readonly onHome: () => void;
}

export function createConnectionBanner(options: ConnectionBannerOptions): HTMLElement {
  const view = el('div', 'net-banner');
  view.dataset.testid = 'connection-lost';
  view.setAttribute('role', 'status');

  view.append(
    el('span', 'net-banner__dot'),
    el('p', 'net-banner__text', 'Connexion perdue — reprise de votre place en cours…'),
  );

  const actions = el('div', 'net-banner__actions');
  const retry = button('Réessayer', 'connection-retry', 'button button--small');
  retry.addEventListener('click', () => options.onRetry());
  const home = button(
    'Retour à l’accueil',
    'connection-home',
    'button button--small button--ghost',
  );
  home.addEventListener('click', () => options.onHome());
  actions.append(retry, home);
  view.append(actions);

  return view;
}
